import { PropsWithChildren } from 'react';
import { FormRow, FormRowProps } from '@features/components/CaseFormBlocks/components';

// This form's design uses a fixed-width label column, unlike FormRow's default proportional layout.
export const DonorFormRow = ({ contentClass, ...props }: PropsWithChildren<FormRowProps>) => (
  <FormRow
    labelClass="w-[208px] shrink-0 text-base-20"
    contentClass={`min-w-0 flex-1 ${contentClass ?? ''}`}
    {...props}
  />
);
